import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { DeleteAppDetailsParams, HomeEditionService } from 'src/Services/API';

import { MutationKeys, QueryKeys } from '../types';

export const useDeleteAppDetails = () => {
  const queryClient = useQueryClient();

  return useMutation(
    [MutationKeys.deleteAppDetails],
    async (params: DeleteAppDetailsParams) => {
      return await HomeEditionService.homeEditionControllerDeleteAppDetails({ body: params });
    },
    {
      onSuccess: () => {
        toast.success("les détails de l'app ont été supprimés");
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchAppDetails] });
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchAppDetails] });
        switch (error.response?.status) {
          case 403:
            toast.error("droits insuffisants pour supprimer les détails de l'app");
            break;
          default:
            toast.error("erreur lors de la suppression des détails de l'app");
        }
      },
    }
  );
};
